import React from 'react'
import { Box, Button, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { IoAddOutline } from "react-icons/io5";
import BookingTable from '../../components/BookingTable';
import BookingModal from '../../components/BookingModal';
// import { useBookingStore } from '../../zustand';
import Booking from '../../components/Booking';
import { CalStatus } from '../../types/cal-status.type';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

const BookingRenderer = () => {
  const [value, setValue] = React.useState('1');
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', my: 2 }}>
          <TabList onChange={handleChange} aria-label="bookings tabs">
            <Tab label="Upcoming" value="1" />
            <Tab label="Unconfirmed" value="2" />
          </TabList>
        </Box>
        <TabPanel value="1" sx={{
          px: 0
        }}>
          <Booking status={CalStatus.UPCOMING} />
        </TabPanel>
        <TabPanel value="2" sx={{
          px: 0
        }}>
          <Booking status={CalStatus.UNCONFIRMED} />
        </TabPanel>
      </TabContext>
    </Box>
  );
};


function Bookings() {
  return (
    <>
      <Box p={2} className="booking-list-wrapper">
        <Grid container>
          <Grid item>
            <Typography
              variant="h5" fontWeight={500} className="title" gutterBottom>
              Bookings
            </Typography>
          </Grid>
          <Grid item ml="auto">
            <Button
              component={Link}
              to="/booking/edit"
              variant='contained'
              endIcon={<IoAddOutline />}
            >Create New</Button>
          </Grid>
        </Grid>
        <BookingRenderer />
        <BookingModal />
      </Box>
    </>
  )
}

export default Bookings
